import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the notifier state domain
 */

const selectNotifierDomain = state => state.notifier || initialState;

const makeSelectNotifierState = () =>
  createSelector(
    selectNotifierDomain,
    subState => subState
  );

/**
 * Other specific selectors
 */

const makeSelectNotifications = () =>
  createSelector(
    selectNotifierDomain,
    subState => subState.notifications
  );

export { makeSelectNotifierState, makeSelectNotifications };
